import { useEffect, useState } from 'react';

import { labels } from '../labels.js';
import { Icon } from './Icon.js';

/**
 * "Reconnecting" bar. The socket starts disconnected: the bar waits a moment
 * before showing, so a normal page load never flashes a false alarm.
 */
export function ConnectionBanner({ connected }: { connected: boolean }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (connected) {
      setVisible(false);
      return;
    }
    const timer = window.setTimeout(() => setVisible(true), 2000);
    return () => window.clearTimeout(timer);
  }, [connected]);

  if (!visible) return null;
  return (
    <div role="status" className="status-bar status-bar--warning">
      <Icon name="wifi-off" size={18} />
      {labels.errors.connectionLost}
    </div>
  );
}
